<template>
  <div class="wrapper">
    <div class="contnet-title">芭田追溯管理平台 · 登录</div>
    <div class="loginwrap">
      <div class="banner">
        <img src="../../image/logo/admin_banner.png" alt="" />
      </div>
      <div class="content">
        <div class="title">欢迎登录芭田追溯平台</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          @keyup.enter.native="submitForm('ruleForm')"
        >
          <el-form-item prop="username">
            <el-input
              v-model="ruleForm.username"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code" class="code-item">
            <el-input
              v-model="ruleForm.code"
              placeholder="请输入验证码"
              class="input3"
            ></el-input
            ><img
              :src="verificationImg"
              @click="checkImageCode"
              class="image"
            />
          </el-form-item>
          <el-button type="primary" size="" @click="submitForm('ruleForm')" style="letter-spacing:15px;font-size:16px;text-indent:15px;"
            >登录</el-button
          >
          <div class="tips">如果忘记密码，请联系管理员</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { queryUserFlag, validateImgCode, adminLogin } from "@/common/api.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
        code: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [
          { required: true, validator: this.validateCode, trigger: "blur" },
        ],
      },
      userFlag: "", //随机标识
      verificationImg: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = {
            userAccount: this.ruleForm.username,
            userPwd: this.ruleForm.password,
          };
          adminLogin(params).then((res) => {
            console.log("adminLogin :>> ", res);
            if (res.errorCode == 200) {
              var token = res.token;
              var userType = res.userType;
              var userData = JSON.stringify(res.systemUser);
              var list = res.systemUser.systemNavigationList;
              this.$store.dispatch("getmeunList", list);
              window.sessionStorage.setItem("token", token);
              window.sessionStorage.setItem("userData", userData);
              window.sessionStorage.setItem("userType", userType);
              this.$router.push({
                path: "/admin/home/index",
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    getImageCode(userFlag) {
      this.$axios({
        method: "post",
        url: "/permissions/regist/createValidateImg",
        data: {
          userFlag: userFlag,
        },
        responseType: "arraybuffer",
        ContentType: "application/json;charset=UTF-8",
      }).then((response) => {
        console.log("res :>> ", response);
        if (response.data) {
          this.verificationImg =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
        }
      });
    },
    checkImageCode() {
      this.getqueryUserFlag();
    },
    getqueryUserFlag() {
      queryUserFlag().then((res) => {
        if (res.errorCode == 200) {
          this.userFlag = res.userFlag;
          this.getImageCode(this.userFlag);
        }
      });
    },
    validateCode(rule, value, callback) {
      var params = {
        userFlag: this.userFlag,
        imageCheckCode: value,
      };
      if (value == "") {
        callback(new Error("请输入验证码"));
      }
      if (value) {
        validateImgCode(params).then((res) => {
          if (res.errorCode != 200) {
            callback(new Error(res.msg));
          }
          callback();
        });
      }
    },
  },
  created() {},
  mounted() {
    this.getqueryUserFlag();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  .contnet-title {
    height: 80px;
    background-color: #4e97d9;
    color: #ffffff;
    font-size: 24px;
    font-weight: bold;
    line-height: 80px;
    padding-left: 50px;
  }
  .loginwrap {
    width: 100%;
    height: calc(100% - 80px);
    .banner {
      width: 60%;
      height: 100%;
      position: relative;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 80%;
        height: auto;
        transform: translate(-50%,-50%);
      }
    }
    .content {
      position: absolute;
      right: 15%;
      top: 50%;
      width: 20%;
      transform: translateY(-50%);
      .title {
        font-size: 20px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        text-align: center;
      }
      .el-form {
        margin-top: 20px;
        .input3 {
          width: 100%;
        }
        .el-button {
          width: 100%;
        }
      }
      .code-item {
        /deep/.el-form-item__content {
          position: relative;

          .image {
            position: absolute;
            right: 2px;
            top: 2px;
            width: auto;
            height: 36px;
          }
        }
      }
    }
  }
  .tips{
    line-height: 50px;
    text-align: right;
    font-size: 14px;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/login.vue